import { type FC, type ReactNode } from 'react';
import classNames from 'classnames';

import dibsCss from 'dibs-css';

type WellProps = {
    className?: string;
    children?: ReactNode;
    label?: ReactNode;
    labelClassName?: string;
    hasClearfix?: boolean;
    hasPadding?: boolean;
    hasMargin?: boolean;
    dataTn?: string;
    hasBorder?: boolean;
};

export const Well: FC<WellProps> = ({
    className,
    children,
    label,
    labelClassName,
    hasClearfix = true,
    hasPadding = true,
    hasMargin = true,
    hasBorder = false,
    dataTn,
}) => (
    <div
        className={classNames(
            {
                clearfix: hasClearfix,
                [dibsCss.pSmall]: hasPadding,
                [dibsCss.mtXsmall]: hasMargin,
                [dibsCss.mbSmall]: hasMargin,
            },
            hasBorder
                ? [
                      dibsCss.border,
                      dibsCss.borderSolid,
                      dibsCss.borderDolphin,
                      dibsCss.roundedXxsmall,
                  ]
                : [
                      dibsCss.sassyFontBodySizeNone,
                      dibsCss.bgWhite,
                      dibsCss.minHSmall,
                      dibsCss.boxShadowDarker,
                  ],
            className
        )}
        data-tn={dataTn}
    >
        {label && (
            <div className={classNames(labelClassName, dibsCss.sassyFontHeader)}>{label}</div>
        )}
        {children}
    </div>
);
